<template>
  <div class="box">
    <span class="tit">{{ tit }}:</span>
    <Echart :id="id" :options="options" height="60px" width="550px"></Echart>
    <span class="title">个</span>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      number: 0,
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: String,
      default: () => []
    },
    id: {
      type: String,
      required: true,
      default: "leftTopChart"
    },
    tit: {
      type: String,
      required: true,
      default: "网点总数"
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        this.number = newData;
        this.options = {
          graphic: this.initGraphic(this.number)
        };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    initGraphic(num) {
      var str = num + "";
      var graphics = {
        type: "group",
        left: "center",
        top: "middle",
        width: str.length * 60,
        children: []
      };
      // 生成数字
      for (var i = 0; i < str.length; i++) {
        graphics.children.push(this.initNum(i));
      }
      // 标题
      // graphics.children.push({
      //   type: "text",
      //   left: "left",
      //   top: 40,
      //   style: {
      //     fill: "#fff",
      //     text: "总数",
      //     font: "16px Microsoft YaHei"
      //   }
      // });
      return graphics;
    },
    initNum(i) {
      return {
        type: "group",
        left: i * 60,
        top: 0,
        width: 100,
        height: 100,
        bounding: "raw",
        children: [
          {
            type: "rect",
            left: "center",
            top: 25,
            style: {
              fill: "#165894"
            },
            shape: {
              width: 50,
              height: 25
            }
          },
          {
            type: "rect",
            left: "center",
            top: 50,
            style: {
              fill: "#124a7b"
            },
            shape: {
              width: 50,
              height: 25
            }
          },
          {
            id: "num-" + i,
            type: "text",
            left: "center",
            top: "middle",
            style: {
              fill: "#fff",
              text: 0,
              font: "30px Microsoft YaHei"
            }
          }
        ]
      };
    },
    start() {
      var chartDom = document.getElementById(this.id);
      var myChart = this.$echarts.init(chartDom);
      var index = this.number - 100;
      let num = this.number;
      index = index < 0 ? 0 : index;

      var timer = setInterval(function() {
        if (++index == num) {
          clearInterval(timer);
        }
        var graphics = {
          type: "group",
          children: []
        };
        var str = index + "";
        str = fn1(str,5)
        function fn1(num, length) {
          return (num / Math.pow(10, length)).toFixed(length).substr(2);
        }
        for (var i = 0; i < str.length; i++) {
          graphics.children.push({
            id: "num-" + i,
            type: "text",
            style: {
              text: str[i]
            }
          });
        }
        myChart.setOption({
          graphic: graphics
        });
      }, 10);
    }
  },
  mounted() {
    this.start();
  }
};
</script>
<style lang="scss" scope>
.box {
  width: 100%;
  height: 100%;
  margin-top: 90px;
  margin-left: 50px;
  .tit {
    float: left;
    margin-top: 18px;
    font-size: 28px;
  }
  .title {
    float: right;
    margin-top: -40px;
    margin-right: 56px;
    font-size: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/screen/components/leftTopChart/index.vue